export const AIRPORTS = [
    // India Major
    { code: 'BOM', city: 'Mumbai', country: 'India' },
    { code: 'DEL', city: 'Delhi', country: 'India' },
    { code: 'BLR', city: 'Bangalore', country: 'India' },
    { code: 'MAA', city: 'Chennai', country: 'India' },
    { code: 'HYD', city: 'Hyderabad', country: 'India' },
    { code: 'CCU', city: 'Kolkata', country: 'India' },
    { code: 'AMD', city: 'Ahmedabad', country: 'India' },
    { code: 'PNQ', city: 'Pune', country: 'India' },
    { code: 'GOI', city: 'Goa (Dabolim)', country: 'India' },
    { code: 'GOX', city: 'Goa (Mopa)', country: 'India' },
    { code: 'COK', city: 'Kochi', country: 'India' },
    { code: 'TRV', city: 'Thiruvananthapuram', country: 'India' },
    { code: 'ATQ', city: 'Amritsar', country: 'India' },
    { code: 'JAI', city: 'Jaipur', country: 'India' },
    { code: 'LKO', city: 'Lucknow', country: 'India' },
    // Middle East
    { code: 'DXB', city: 'Dubai', country: 'UAE' },
    { code: 'AUH', city: 'Abu Dhabi', country: 'UAE' },
    { code: 'SHJ', city: 'Sharjah', country: 'UAE' },
    { code: 'DOH', city: 'Doha', country: 'Qatar' },
    { code: 'MCT', city: 'Muscat', country: 'Oman' },
    { code: 'RUH', city: 'Riyadh', country: 'Saudi Arabia' },
    { code: 'JED', city: 'Jeddah', country: 'Saudi Arabia' },
    { code: 'BAH', city: 'Bahrain', country: 'Bahrain' },
    { code: 'KWI', city: 'Kuwait City', country: 'Kuwait' },
    // Asia Pacific
    { code: 'SIN', city: 'Singapore', country: 'Singapore' },
    { code: 'BKK', city: 'Bangkok (Suvarnabhumi)', country: 'Thailand' },
    { code: 'DMK', city: 'Bangkok (Don Mueang)', country: 'Thailand' },
    { code: 'HKT', city: 'Phuket', country: 'Thailand' },
    { code: 'KUL', city: 'Kuala Lumpur', country: 'Malaysia' },
    { code: 'CGK', city: 'Jakarta', country: 'Indonesia' },
    { code: 'DPS', city: 'Bali (Denpasar)', country: 'Indonesia' },
    { code: 'HKG', city: 'Hong Kong', country: 'Hong Kong' },
    { code: 'NRT', city: 'Tokyo (Narita)', country: 'Japan' },
    { code: 'HND', city: 'Tokyo (Haneda)', country: 'Japan' },
    { code: 'KIX', city: 'Osaka', country: 'Japan' },
    { code: 'SGN', city: 'Ho Chi Minh City', country: 'Vietnam' },
    { code: 'HAN', city: 'Hanoi', country: 'Vietnam' },
    { code: 'CMB', city: 'Colombo', country: 'Sri Lanka' },
    { code: 'MLE', city: 'Malé', country: 'Maldives' },
    // Europe
    { code: 'LHR', city: 'London (Heathrow)', country: 'UK' },
    { code: 'LGW', city: 'London (Gatwick)', country: 'UK' },
    { code: 'CDG', city: 'Paris', country: 'France' },
    { code: 'FRA', city: 'Frankfurt', country: 'Germany' },
    { code: 'MUC', city: 'Munich', country: 'Germany' },
    { code: 'AMS', city: 'Amsterdam', country: 'Netherlands' },
    { code: 'ZRH', city: 'Zurich', country: 'Switzerland' },
    { code: 'FCO', city: 'Rome', country: 'Italy' },
    { code: 'MXP', city: 'Milan', country: 'Italy' },
    { code: 'MAD', city: 'Madrid', country: 'Spain' },
    { code: 'BCN', city: 'Barcelona', country: 'Spain' },
    { code: 'IST', city: 'Istanbul', country: 'Turkey' },
    { code: 'ATH', city: 'Athens', country: 'Greece' },
    // Americas
    { code: 'JFK', city: 'New York (JFK)', country: 'USA' },
    { code: 'EWR', city: 'New York (Newark)', country: 'USA' },
    { code: 'LAX', city: 'Los Angeles', country: 'USA' },
    { code: 'SFO', city: 'San Francisco', country: 'USA' },
    { code: 'ORD', city: 'Chicago', country: 'USA' },
    { code: 'YYZ', city: 'Toronto', country: 'Canada' },
    { code: 'YVR', city: 'Vancouver', country: 'Canada' },
    // Africa/Oceania
    { code: 'CPT', city: 'Cape Town', country: 'South Africa' },
    { code: 'JNB', city: 'Johannesburg', country: 'South Africa' },
    { code: 'SYD', city: 'Sydney', country: 'Australia' },
    { code: 'MEL', city: 'Melbourne', country: 'Australia' },
    { code: 'AKL', city: 'Auckland', country: 'New Zealand' }
];

// Provide popular array for quick chips
export const POPULAR_AIRPORTS = [
    { code: 'BOM', city: 'Mumbai' },
    { code: 'DEL', city: 'Delhi' },
    { code: 'BLR', city: 'Bangalore' },
    { code: 'MAA', city: 'Chennai' },
    { code: 'DXB', city: 'Dubai' },
    { code: 'SIN', city: 'Singapore' },
    { code: 'BKK', city: 'Bangkok' },
    { code: 'LHR', city: 'London' }
];
